type RoomValidationErrorKind = 'empty-room';

export class RoomValidationError extends Error {
  kind: RoomValidationErrorKind;
  constructor(kind: RoomValidationErrorKind) {
    super(kind);
    this.name = 'RoomValidationError';
    this.kind = kind;
    this.stack = new Error().stack;
  }
}
